<template>
  <app-types-checkbox :label="$t('PACKAGING_TYPES_CHECKBOX.TITLE')"
                      :types="packagingTypes"
                      :value="value"
                      @input="emit"
                      v-loading="isLoading">
  </app-types-checkbox>
</template>

<script>
import facetsService from '@/services/facetsService'
import AppTypesCheckbox from '../types-checkbox/TypesCheckbox'

export default {
  name: 'AppPackagingTypesCheckbox',
  components: { AppTypesCheckbox },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isLoading: false,
      packagingTypes: []
    }
  },
  created () {
    this.getPackagingTypes()
  },
  methods: {
    async getPackagingTypes () {
      this.isLoading = true

      try {
        this.packagingTypes = await facetsService.findAllPackagingTypes()
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        throw error
      }

      this.isLoading = false
    },
    emit (value) {
      this.$emit('input', value)
    }
  }
}
</script>
